import React, { useEffect } from 'react';

import useJobProgressPoller from '../hooks/useJobProgressPoller';
import useJobProgressStore from '../stores/jobProgressStore';
import JobProgressModal from './JobProgressModal';
import JobProgressToast from './JobProgressToast';

/**
 * App-wide host for the job-progress UX. Mounted once (App.js, beside
 * ConfirmModal) so the modal + toasts survive route navigation. Runs the single
 * poller and renders the focused job's modal plus a toast for every other job.
 */
const GlobalJobProgress = () => {
  useJobProgressPoller();

  // One-time hygiene: drop persisted jobs that never resolved (>24h old or
  // missing a tracked-at stamp from before it existed) so a stale entry can't
  // keep the poller hitting its status endpoint across sessions.
  useEffect(() => {
    useJobProgressStore.getState().evictStale();
  }, []);

  const jobs = useJobProgressStore(s => s.jobs);
  const focusedJobId = useJobProgressStore(s => s.focusedJobId);

  const focused = focusedJobId ? jobs[focusedJobId] : null;
  const modalJob = focused && !focused._minimized ? focused : null;
  const toastJobs = Object.values(jobs).filter(job => !modalJob || job.id !== modalJob.id);

  return (
    <>
      {modalJob && <JobProgressModal job={modalJob} />}
      <JobProgressToast jobs={toastJobs} />
    </>
  );
};

export default GlobalJobProgress;
